<template>
  <div class="incompleted-detail">
    <div class="title">불완전 결제 상세</div>

    <div class="detail">
      <div class="image-area">
        <div class="images">
          <div class="image scroll" ref="image">
            <img
              v-if="selectedImage"
              :src="selectedImage.src"
              :width="selectedImage.width * selectedImage.scale + 'px'"
              :height="selectedImage.height * selectedImage.scale + 'px'"
              alt
            />
            <div v-else>
              {{ errMsg }}
            </div>
          </div>
          <Spinner
            class="spinner"
            v-if="loadingImage"
            width="120"
            height="120"
            size="8"
          ></Spinner>

          <!-- TODO
          <div class="sub-image scroll">
            <div v-for="(img, camera, i) in image" :key="camera">
              <div v-if="i < 6">
                <img v-if="img" :src="img.src" alt
                  :class="selectedCamera === camera ? 'selected' : ''"
                  @click="selectCamera(camera)"/>
                <img v-else src="/static/img/ico-pending-grey.png" alt
                  :class="selectedCamera === camera ? 'selected' : ''"
                  @click="selectCamera(camera)"/>
              </div>
            </div>
          </div>
          -->
          <!-- TODO
          <div class="sub-image scroll">
            <div>
              <img v-if="image.video0" :src="image.video0.src" alt
                :class="selectedCamera === 'video0' ? 'selected' : ''"
                @click="selectCamera('video0')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video0' ? 'selected' : ''"
                @click="selectCamera('video0')"/>
            </div>
            <div>
              <img v-if="image.video2" :src="image.video2.src" alt
                :class="selectedCamera === 'video2' ? 'selected' : ''"
                @click="selectCamera('video2')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video2' ? 'selected' : ''"
                @click="selectCamera('video2')"/>
            </div>
            <div>
              <img v-if="image.video4" :src="image.video4.src" alt
                :class="selectedCamera === 'video4' ? 'selected' : ''"
                @click="selectCamera('video4')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video4' ? 'selected' : ''"
                @click="selectCamera('video4')"/>
            </div>
            <div>
              <img v-if="image.video6" :src="image.video6.src" alt
                :class="selectedCamera === 'video6' ? 'selected' : ''"
                @click="selectCamera('video6')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video6' ? 'selected' : ''"
                @click="selectCamera('video6')"/>
            </div>
            <div>
              <img v-if="image.video8" :src="image.video8.src" alt
                :class="selectedCamera === 'video8' ? 'selected' : ''"
                @click="selectCamera('video8')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video8' ? 'selected' : ''"
                @click="selectCamera('video8')"/>
            </div>
            <div>
              <img v-if="image.video10" :src="image.video10.src" alt
                :class="selectedCamera === 'video10' ? 'selected' : ''"
                @click="selectCamera('video10')"/>
              <img v-else src="/static/img/ico-pending-grey.png" alt
                :class="selectedCamera === 'video10' ? 'selected' : ''"
                @click="selectCamera('video10')"/>
            </div>
          </div>
          -->


        </div>

        <input
          v-if="selectedURLs && selectedURLs.length !== 0"
          v-model="imageIndex"
          type="range"
          min="0"
          :max="selectedURLs.length - 1"
          class="slider"
        />
      </div>


      <!-- TODO -->
      <div class="subimages scroll">
        <!--
        <div v-for="(img, camera, i) in computedImage" :key="camera">
          <div v-if="i < cameraCount">
            <img v-if="img" :src="img.src" alt
              :class="selectedCamera === camera ? 'selected' : ''"
              @click="selectCamera(camera)"/>
            <img v-else src="/static/img/ico-pending-grey.png" alt
              :class="selectedCamera === camera ? 'selected' : ''"
              @click="selectCamera(camera)"/>
          </div>
        </div>
        -->
        <div v-for="(img, camera) in computedImage" :key="camera">
          <img v-if="img" :src="img.src" alt
            :class="selectedCamera === camera ? 'selected' : ''"
            @click="selectCamera(camera)"/>
          <img v-else src="/static/img/ico-pending-grey.png" alt
            :class="selectedCamera === camera ? 'selected' : ''"
            @click="selectCamera(camera)"/>
        </div>
      </div>


      <div class="products scroll">
        <div
          v-if="
            !incompleted.products ||
            Object.keys(incompleted.products).length === 0
          "
          class="type"
        >
          상품이 없습니다.
        </div>

        <div v-else>
          <div v-for="(products, type) in incompleted.products" :key="type">
            <div class="type">
              {{ type }}
            </div>

            <div
              v-for="product in products"
              class="product"
              :key="product.productID"
            >
              <div class="product-preview">
                <ProductThumbnail :product="product" :zoom="true"/>
              </div>
              <div class="product-name">
                {{ product.productName }}
              </div>

              <div class="ctrl">
                <button class="btn" @click="subProductCount(product)">-</button>
                <div class="count" :class="product.count === 0 ? 'zero' : ''">
                  {{ product.count }}
                </div>
                <button class="btn" @click="addProductCount(product)">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
/* eslint-disable no-continue */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ProductThumbnail from '@/components/product/ProductThumbnail';

export default {
  components: {
    ProductThumbnail,
  },
  props: ['tab', 'selectedID', 'uID'],
  data: () => ({
    beforeSelectedID: null,
    loading: true,
    interval: null,
    // initData begin
    incompleted: {},
    imageIndex: 0,
    image: {},
    selectedImage: null,
    selectedCamera: 'video0',
    selectedURLs: null,
    cameraCount: 0,
    loadingImage: true,
    // initData end
    errMsg: '이미지가 없습니다',
  }),
  created() {
    this.initData();

    window.addEventListener('resize', this.getImageScale);

    this.interval = setInterval(() => {
      if (!this.loading && this.selectedID && this.incompleted.imageState !== 2) {
        this.fetchPay(this.selectedID, true);
      }
    }, 5000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getImageScale);

    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
  watch: {
    selectedID: {
      handler() {
        if (!this.selectedID) {
          return;
        }

        this.fetchPay(this.selectedID, false);
      },
      immediate: true,
    },
    incompleted: {
      handler() {
        if (!this.incompleted.ID) {
          this.$emit('setIncompleted', null);
        }
        this.$emit('setIncompleted', this.incompleted);
      },
      immediate: true,
      deep: true,
    },
    imageIndex() {
      if (
        !this.incompleted.imageURLs ||
        !this.selectedURLs ||
        this.selectedURLs.length <= this.imageIndex
      ) {
        return;
      }

      this.getImage(this.incompleted.imageURLs, this.imageIndex);
    },
  },
  computed: {
    computedImage() {
      const image = {};
      for (let i = 0; i < 30; i++) { // total 30
        const camera = `video${i * 2}`;
        if (this.image[camera]) {
          image[camera] = this.image[camera];
        }
      }
      return image;
    },
  },
  methods: {
    initData() {
      this.incompleted = {
        ID: null,
        deviceID: null,
        products: null,
        imageURLs: null,
        imageState: 0,
      };
      this.imageIndex = 0;
      this.image = { // total 30
        video0: null,
        video2: null,
        video4: null,
        video6: null,
        video8: null,
        video10: null,
        video12: null,
        video14: null,
        video16: null,
        video18: null,
        video20: null,
        video22: null,
        video24: null,
        video26: null,
        video28: null,
        video30: null,
        video32: null,
        video34: null,
        video36: null,
        video38: null,
        video40: null,
        video42: null,
        video44: null,
        video46: null,
        video48: null,
        video50: null,
        video52: null,
        video54: null,
        video56: null,
        video58: null,
      };
      this.selectedImage = null;
      this.selectedCamera = 'video0';
      this.selectedURLs = null;
      this.cameraCount = 0;
      this.loadingImage = true;
    },
    async fetchPay(ID, polling) {
      this.loading = true;
      if (this.beforeSelectedID !== ID) {
        this.initData();
        this.beforeSelectedID = ID;
      }

      try {
        const incompleted = {
          ID: null,
          deviceID: null,
          products: null,
          imageURLs: null,
          imageState: 0,
        };
        let cameraCount = 0;

        const pay = await this.$http.post(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/payment/${ID}`,
          {
            uID: this.uID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (pay.status !== 200) {
          throw new Error(`Response status is "${pay.status}"`);
        }
        if (pay.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${pay.data.resultCode}"`);
        }

        incompleted.ID = pay.data.payment.paymentID;
        incompleted.deviceID = pay.data.payment.deviceID;
        incompleted.imageState = pay.data.payment.imageState;

        if (pay.data.payment.paymentImages) {
          const urls = {};
          for (let i = 0; i < pay.data.payment.paymentImages.length; i++) {
            const fileURL = pay.data.payment.paymentImages[i].fileURL;
            const split = fileURL.split('/');
            if (split.length < 2) {
              continue;
            }
            const videoIndex = split[split.length - 2];

            if (
              fileURL.startsWith('https://') ||
              fileURL.startsWith('http://')
            ) {
              if (!urls[videoIndex]) {
                cameraCount++;
                urls[videoIndex] = [];
              }
              urls[videoIndex].push(fileURL);
              continue;
            }

            if (!urls[videoIndex]) {
              cameraCount++;
              urls[videoIndex] = [];
            }
            urls[videoIndex].push(
              `${Configuration.value('CPAYMENT_ADDRESS')}/${fileURL}`,
            );
          }

          const keys = Object.keys(urls);
          for (let i = 0; i < keys.length; i++) {
            urls[keys[i]].sort();
          }
          incompleted.imageURLs = urls;
        }

        if (this.incompleted.ID !== incompleted.ID && incompleted.deviceID) {
          const products = {};
          for (let i = 1; ; i++) {
            const device = await this.$http.get(
              `${Configuration.value(
                'CPRODUCT_ADDRESS',
              )}/api/v1/cproduct/device/${
                incompleted.deviceID
              }/product/list?page=${i}&limit=500&showDeleted=false`,
              {
                headers: {
                  Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
                },
              },
            );
            if (device.status !== 200) {
              if (device.status === 204) {
                break;
              }
              throw new Error(`Response stauts is "${device.status}"`);
            }
            if (device.data.resultCode !== '0000') {
              throw new Error(`ResultCode is "${device.data.resultCode}"`);
            }

            for (let j = 0; j < device.data.products.length; j++) {
              const product = device.data.products[j];
              if (product.productType in products) {
                const cp = JSON.parse(JSON.stringify(product));
                cp.count = 0;
                products[product.productType].push(cp);
              } else {
                const cp = JSON.parse(JSON.stringify(product));
                cp.count = 0;
                products[product.productType] = [cp];
              }
            }
          }
          incompleted.products = products;
        } else {
          incompleted.products = this.incompleted.products;
        }

        //
        this.incompleted = incompleted;
        if (!this.selectedURLs) {
          this.selectedCamera = 'video0';
          if (incompleted.imageURLs && incompleted.imageURLs.video0) {
            this.selectedURLs = this.incompleted.imageURLs.video0;
          } else {
            this.selectedURLs = null;
          }
        }
        this.cameraCount = cameraCount;
        this.loading = false;

        //
        if (this.incompleted.imageURLs) {
          this.getImage(this.incompleted.imageURLs, this.imageIndex);
        } else {
          this.loadingImage = false;
        }
        this.$nextTick(this.setSliderWidth);
      } catch (e) {
        this.loading = false;
        this.loadingImage = false;

        if (e.response) {
          if (e.response.status === 409) {
            if (!polling) {
              alert(
                '처리 중인 작업입니다.\n다른 작업을 선택하거나, 새로고침 해주세요.',
              );
            }
            this.$emit('refresh');
            return;
          }
        }

        if (!polling) {
          alert('정보를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        }
        console.error(e);
      }
    },
    setSliderWidth() {
      if (!this.selectedURLs) {
        return;
      }

      const elems = document.getElementsByClassName('slider');
      if (elems.length !== 1) {
        return;
      }

      const slider = elems[0];
      slider.style.setProperty(
        '--slider-width',
        `calc(100%/${this.selectedURLs.length}`,
      );
    },
    async getImage(urls, index) {
      try {
        const keys = Object.keys(urls);
        for (let i = 0; i < keys.length; i++) {
          if (urls[keys[i]].length <= index) {
            this.image[keys[i]] = null;
            continue;
          }

          // TODO
          if (this.selectedCamera !== keys[i] && this.image[keys[i]]) {
            continue;
          }

          const url = urls[keys[i]][index];
          if (!url) {
            continue;
          }
          const res = await this.$http.get(url, {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
            responseType: 'arraybuffer',
          });
          if (res.status !== 200) {
            throw new Error(`Response stauts is "${res.status}"`);
          }

          const src = `data:image/jpeg;base64,${Buffer.from(
            res.data,
            'binary',
          ).toString('base64')}`;
          const img = new Image();
          img.onload = () => {
            this.image[keys[i]] = {
              src,
              width: img.width,
              height: img.height,
              scale: 1,
            };

            //
            if (this.selectedCamera === keys[i]) {
              this.selectedImage = this.image[keys[i]];
            }
            this.loadingImage = false;

            this.getImageScale();
          };
          img.onerror = (e) => {
            console.error('image load error', e);
            if (this.selectedCamera === keys[i]) {
              this.selectedImage = null;
            }
            this.loadingImage = false;
          };
          img.src = src;
        }
      } catch (e) {
        console.error('getImage error', e);
        this.imageIndex = 0;
        this.loadingImage = false;

        // alert('이미지를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.');
        this.errMsg = '이미지를 가져오지 못했습니다.\n잠시후 다시 시도해주세요.';
      }
    },
    getImageScale() {
      if (!this.selectedImage) {
        return;
      }
      const elem = this.$refs.image;
      if (!elem) {
        return;
      }

      let scale = 1;
      if (this.selectedImage.width > elem.clientWidth) {
        scale =
          Math.floor((elem.clientWidth / this.selectedImage.width) * 10) / 10;
        if (scale < 0.1) {
          scale = 0.1;
        }
      }
      if (scale > 0.1 && this.selectedImage.height * scale > elem.clientHeight) {
        scale =
          Math.floor((elem.clientHeight / this.selectedImage.height) * 10) / 10;
        if (scale < 0.1) {
          scale = 0.1;
        }
      }

      for (;;) {
        if (scale > 9.9) {
          break;
        }
        const tmp = scale + 0.1;
        if (
          this.selectedImage.width * tmp > elem.clientWidth ||
          this.selectedImage.height * tmp > elem.clientHeight
        ) {
          break;
        }
        scale = tmp;
      }

      this.selectedImage.scale = scale;
    },
    subProductCount(product) {
      if (!product.count) {
        return;
      }
      product.count--;
    },
    addProductCount(product) {
      product.count++;
    },
    selectCamera(camera) {
      this.selectedCamera = camera;
      if (this.incompleted.imageURLs && this.incompleted.imageURLs[this.selectedCamera]) {
        this.selectedURLs = this.incompleted.imageURLs[this.selectedCamera];
      } else {
        this.selectedImage = null;
        this.selectedURLs = null;
      }
      // this.imageIndex = 0; // TODO
      if (this.selectedURLs && this.selectedURLs.length <= this.imageIndex) {
        this.imageIndex = this.selectedURLs.length - 1;
      }
      if (this.incompleted.imageURLs) {
        this.getImage(this.incompleted.imageURLs, this.imageIndex);
      }
      this.$nextTick(this.setSliderWidth);
    },
  },
};
</script>

<style scoped>
.incompleted-detail .detail {
  display: flex;
  margin-top: 24px;
  width: 100%;
  height: 540px;
  background-color: #e3e5e8;
}
.detail .scroll::-webkit-scrollbar-corner {
  background-color: inherit;
}
.detail .scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.detail .scroll::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: gray;
}
.detail .scroll::-webkit-scrollbar-button {
  width: 0;
  height: 0;
}
.detail .image-area {
  position: relative;
  width: 100%;
  height: 100%;
}
.detail .products {
  padding: 20px;
  padding-bottom: 0;
  min-width: 380px;
  width: 380px;
  max-width: 380px;
  height: 100%;
  font-size: 14.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #192124;
  background-color: #f3f5f8;
  overflow-y: auto;
}
.image-area .images {
  display: flex;
  width: 100%;
  height: calc(100% - 16px);
}
.image-area .image {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  overflow: auto;
}
.image-area .sub-image {
  width: 160px;
  height: 100%;
}
.image-area .sub-image div {
  width: 160px;
  height: 90px;
  background-color: #787878;
}
.image-area .sub-image img {
  width: 160px;
  height: 90px;
}
.image-area .sub-image img.selectedTODO {
  border: solid 2px #0058ee;
}
.image-area .spinner {
  position: absolute;
  top: calc(50% - 60px);
  left: calc(50% - 60px);
}
.detail .subimages {
  padding: 0px;
  padding-bottom: 0;
  min-width: 160;
  width: 100%;
  max-width: 168px;
  height: 100%;
  background-color: #f3f5f8;
  overflow-y: auto;
}
.subimages {
  width: 160px;
  height: 100%;
}
.subimages div {
  width: 160px;
  height: 90px;
  background-color: #787878;
}
.subimages img {
  width: 160px;
  height: 90px;
}
.subimages img.selected {
  border: solid 2px #0058ee;
}
.slider {
  appearance: none;
  width: 100%;
  height: 16px;
  background-color: #d3d3d3;
  outline: none;
  --slider-width: 100%;
}
.slider::-webkit-slider-thumb {
  appearance: none;
  min-width: 16px;
  width: var(--slider-width);
  height: 16px;
  background-color: #4082f3;
  background-image: url('/static/img/ico-drag-vertical-variant.png');
  background-size: 16px;
  border-radius: 2px;
  cursor: pointer;
}
.products .type {
  margin-bottom: 28px;
  color: #9d9ea1;
}
.products .product {
  display: flex;
  height: 48px;
  border-bottom: solid 1px #dee0e3;
}
.products .product:last-of-type {
  margin-bottom: 28px;
}
.product .ctrl {
  display: flex;
  margin-left: auto;
  align-items: center;
}

.product .product-name {
  display: flex;
  align-items: center;
}

.product .product-preview {
  height: 48px;
  width: 48px;
}

.ctrl .btn {
  width: 24px;
  height: 24px;
  font-size: 18px;
  text-align: center;
  color: #707276;
  background-color: #ebeef1;
  cursor: pointer;
  user-select: none;
  transition: 0.2s;
}
.ctrl .btn:hover {
  background-color: #e0e0e0;
}
.ctrl .count {
  width: 24px;
  height: 24px;
  font-size: 12px;
  line-height: 24px;
  text-align: center;
}
.ctrl .count.zero {
  color: #9d9ea1;
}
</style>



// WEBPACK FOOTER //
// src/components/incompletedPay/IncompletedDetail.vue